export default __webpack_public_path__ + "static/media/Howdoesitworks.159735a7.webp";